<template>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 32 40" enable-background="new 0 0 32 32" xml:space="preserve"><g><g><path d="M27,6h-3h-3V3c0-0.5522-0.4473-1-1-1h-8c-0.5527,0-1,0.4478-1,1v3H8H5C4.4473,6,4,6.4478,4,7s0.4473,1,1,1h2.0444    L8.001,29.0454C8.0254,29.5796,8.4658,30,9,30h14c0.5342,0,0.9746-0.4204,0.999-0.9546L24.9556,8H27c0.5527,0,1-0.4478,1-1    S27.5527,6,27,6z M13,4h6v2h-6V4z M22.0439,28H9.9561L9.0469,8H12h8h2.9531L22.0439,28z"/><path d="M13,11c-0.5527,0-1,0.4478-1,1v12c0,0.5522,0.4473,1,1,1s1-0.4478,1-1V12C14,11.4478,13.5527,11,13,11z"/><path d="M19,11c-0.5527,0-1,0.4478-1,1v12c0,0.5522,0.4473,1,1,1s1-0.4478,1-1V12C20,11.4478,19.5527,11,19,11z"/></g></g></svg>

</template>

<script>
export default {
    name: 'IconDelete',
}
</script>

<style lang="scss" scoped>
</style>